import { styled } from '@mui/material';
import Box from '@mui/material/Box';

/**
 * A styled Box component used to create a panel with specified styling.
 *
 * @component
 * @returns {JSX.Element}
 */
const Panel = styled(Box)(({ theme }) => ({
    display: 'flex',
    backgroundColor: theme.palette.background.panel,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderRadius: '36px'
}));

export default Panel;
